import { gql } from "lib/apolloClient";
import { ADMFragment } from "./AssignmentAndDeadlineFragments";

export const getAssignmentAndDeadlineQuery = gql`
  query getTeacherTasks(
    $userId: ID!
    $filters: TaskFilter
    $first: Int
    $after: String
    $orderByDirection: ORDER_BY_DIRECTION
    $type: ENTITY_TYPE_ENUM!
    $orderBy: TODOS_ORDER_BY_ENUM
    $includeMessagesSummary: Boolean = false
    $messagesSummaryItemCount: Int = 1
  ) {
    node(id: $userId, type: $type) {
      id
      ... on Staff {
        id
        tasks(
          filters: $filters
          first: $first
          after: $after
          orderByDirection: $orderByDirection
          orderBy: $orderBy
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
            __typename
          }
          totalCount
          edges {
            id
            orderDate
            itemType
            item {
              id
              ... on Assignment {
                ...teacherAssignmentItem
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
    }
  }
  ${ADMFragment.teacherAssignmentItem}
`;

export const getAssignmentAndDeadlineStatusWiseCountQuery = gql`
  query getTeacherTasksStatusWiseCount(
    $userId: ID!
    $filters: TaskFilter
    $first: Int
    $after: String
    $orderByDirection: ORDER_BY_DIRECTION
    $type: ENTITY_TYPE_ENUM!
    $orderBy: TODOS_ORDER_BY_ENUM
  ) {
    node(id: $userId, type: $type) {
      id
      ... on Staff {
        id
        tasks(
          filters: $filters
          first: $first
          after: $after
          orderByDirection: $orderByDirection
          orderBy: $orderBy
        ) {
          statusWiseCount {
            category
            count
          }
        }
      }
    }
  }
`;
